function setCookie(key: string, value: string, expiry: number | string) {
  if (typeof expiry === "string") {
    expiry = parseInt(expiry);
  }
  var expires = new Date();
  expires.setTime(expires.getTime() + expiry * 1000);
  document.cookie = key + "=" + value + ";expires=" + expires.toUTCString();
}

function getCookie(key: string) {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? keyValue[2] : null;
}

function eraseCookie(key: string) {
  var keyValue = getCookie(key);
  setCookie(key, keyValue ?? "", "-1");
}

export { setCookie, eraseCookie, getCookie };
